(function () {
  'use strict';

  // VW: cart guard — blocks checkout if bundle pieces don't add up to a
  // full bundle. Catches carts the builder/cart lock can't, e.g. a single
  // "— Bundle Item" piece added straight from its product URL.
  //
  // Rules (checked against /cart.js, not the page):
  //  1. Any line whose product handle contains "bundle-item" must carry a
  //     _BundleSize property (i.e. it came through the builder).
  //  2. For each _BundleSize ("5-piece", "10-piece"), the total pieces in
  //     the cart with that size must be a whole number of bundles.

  var BLOCK_SEL = '[name="checkout"], #checkout, a[href*="/checkout"], .additional-checkout-buttons, shopify-accelerated-checkout-cart, shopify-accelerated-checkout, .shopify-payment-button';
  var problem = null;

  function check(cart) {
    var loose = 0;
    var sizes = {};
    cart.items.forEach(function (it) {
      if (!it.handle || it.handle.indexOf('bundle-item') === -1) return;
      var bs = it.properties && it.properties._BundleSize;
      if (!bs) { loose += it.quantity; return; }
      sizes[bs] = (sizes[bs] || 0) + it.quantity;
    });
    if (loose) {
      return 'Single pieces can only be bought as part of a bundle (minimum 5). Please remove the single piece and use the Bundle Builder.';
    }
    for (var key in sizes) {
      var n = parseInt(key, 10);
      if (n && sizes[key] % n !== 0) {
        return 'Sorry, minimum order quantity is ' + n + '. Your ' + n + '-piece bundle has ' + (sizes[key] % n) + ' piece' + (sizes[key] % n === 1 ? '' : 's') + ' — please complete it or remove it.';
      }
    }
    return null;
  }

  function injectStyles() {
    if (document.getElementById('vw-guard-style')) return;
    var s = document.createElement('style');
    s.id = 'vw-guard-style';
    s.textContent =
      '.vw-guard-blocked{opacity:.4 !important;pointer-events:none !important;filter:grayscale(1);}' +
      '.vw-guard-msg{margin:0 0 12px;padding:10px 12px;border-radius:10px;background:rgba(220,38,38,.14);border:1px solid rgba(239,68,68,.55);color:#fca5a5;font-size:13.5px;font-weight:700;line-height:1.4;}' +
      '.vw-guard-msg a{color:#4ade80;text-decoration:underline;}';
    document.head.appendChild(s);
  }

  function render() {
    var buttons = document.querySelectorAll(BLOCK_SEL);
    buttons.forEach(function (b) {
      b.classList.toggle('vw-guard-blocked', !!problem);
      if (b.tagName === 'BUTTON') b.disabled = !!problem;
    });
    document.querySelectorAll('.vw-guard-msg').forEach(function (m) { m.remove(); });
    if (!problem) return;
    var first = document.querySelector('[name="checkout"], #checkout');
    if (!first) return;
    var msg = document.createElement('p');
    msg.className = 'vw-guard-msg';
    msg.setAttribute('role', 'alert');
    msg.innerHTML = problem.replace(/</g, '&lt;') + ' <a href="/pages/bundle-builder">Open the Bundle Builder</a>';
    first.parentNode.insertBefore(msg, first);
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { problem = check(cart); render(); })
      .catch(function () {});
  }

  // Last line of defence: stop the click/submit even if a button slips
  // past the disabled state (re-rendered markup, keyboard submit, etc.).
  function stop(e) {
    if (!problem) return;
    var t = e.target;
    var hit = (t.closest && t.closest(BLOCK_SEL)) ||
      (e.type === 'submit' && t.matches && t.matches('form[action*="/cart"]') && e.submitter && e.submitter.name === 'checkout');
    if (!hit) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    render();
    var m = document.querySelector('.vw-guard-msg');
    if (m) m.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('click', stop, true);
  document.addEventListener('submit', stop, true);

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 400); }

  var origFetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var url = typeof a === 'string' ? a : (a && a.url) || '';
    var res = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/i.test(url)) res.then(schedule, schedule);
    return res;
  };

  function init() {
    injectStyles();
    refresh();
    // Re-apply only when the cart re-rendered and lost our state — avoids
    // an observer loop from our own DOM changes.
    new MutationObserver(function () {
      if (!problem) return;
      var stale = !document.querySelector('.vw-guard-msg') && document.querySelector('[name="checkout"], #checkout');
      if (!stale) {
        document.querySelectorAll(BLOCK_SEL).forEach(function (b) { if (!b.classList.contains('vw-guard-blocked')) stale = true; });
      }
      if (stale) render();
    })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
